export type { CoursesWithRulesProps } from './types';

export { default as CoursesWithRules } from './LazyCoursesWithRules';
